import { UserActivityFeature } from '@datum-group/datum-map/lib/types';
import { MouseController } from '.';
import { INewsItem, INewsItemProperties } from '../News/types';
import { SingleWindow } from '../Window';

export class NewsCardMouseControllerLink {
  constructor(
    private _mouseController: MouseController,
    private _card: SingleWindow<INewsItemProperties>,
  ) {}

  bind = () => {
    this._mouseController.on('left_click', this._handler);

    return this.unbind;
  };

  unbind = () => {
    this._mouseController.un('left_click', this._handler);
  };

  private _handler = (targetData: UserActivityFeature) => {
    const [, feature] = targetData;

    if (this._isNewsCard(feature)) {
      this._card.open(feature.properties);

      return;
    }
  };

  private _isNewsCard = (
    value: GeoJSON.Feature<GeoJSON.Geometry | null>,
  ): value is INewsItem => {
    if (value.id === undefined || !Number.isInteger(+value.id)) return false;

    const { properties } = value;

    if (!properties) return false;

    const hasNewsProps =
      'title' in properties &&
      'description' in properties &&
      'address' in properties &&
      'link' in properties &&
      // TODO: Поле 'author' это поле user в эндпоинте open-news-geojson => у фичи такого поля нет
      // 'author' in properties &&
      'date_start' in properties &&
      'date_end' in properties;

    return hasNewsProps;
  };
}
